
import {PromptsList, AddPrompt} from 'components/prompts'
export default {
  components: {
    PromptsList,
    AddPrompt
  },
  emits: ['select-prompt'],
  data(){
    return {
      // for package icon state
      keep_open: false,
      tp_target: undefined,
    }
  },
  mounted(){
    const chat = this.$el.closest('#chat')
    if (chat) {
      this.tp_target = '#chat'
    }
  },
  methods: {
    async onOpen() {
      this.keep_open = true
      this.$refs.list.open()
    },
    createPrompt(data){
      this.$refs.add.open(data)
    },
    onAddCancel(){
      this.$refs.list.open()
    },
    onCloseModal(){
      this.keep_open = false
    },
    selectPrompt(ev){
      this.onCloseModal()
      this.$emit('select-prompt', ev)
    }
  }
}
